import { render, staticRenderFns } from "./RequestCodeLink.vue?vue&type=template&id=28d8f658&"
import script from "./RequestCodeLink.vue?vue&type=script&lang=ts&"
export * from "./RequestCodeLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports